import MLSyllabus from "../../components/Ai_Comp/mlSyllabus";
import GetInTouch from "../../components/common/Contact/GetInTouch";
import CourseFAQ from "../../components/common/CourseFAQ/CourseFAQ";
import CourseHeroSection from "../../components/common/CourseHero/CourseHeroSection";
import CourseReasons from "../../components/common/CourseReasons/CourseReasons";
import PlaceMentRecord from "../../components/common/PlaceMent/PlaceMentRecord";
import ScrollText from "../../components/common/ScrollText/ScrollText";
import SEO from "../../components/common/seo/SEO";
import { mlFaqs } from "../../data/ai_section/mlFaqData";
import { mlReasons } from "../../data/ai_section/mlReasons";

 


const mlFeatures = [
    "Learn Machine Learning from industry professionals.",
    "Build real-world Machine Learning projects from scratch.",
    "Learn supervised and unsupervised learning techniques.",
    "Work with Python, NumPy, Pandas, and Scikit-learn.",
    "Career support, mock interviews, and project guidance.",
];


function MLPage() {

    return (
        <>
<SEO
    title="Machine Learning Course Online | ML Training | FeesWorth"
    description="Learn Machine Learning online through practical projects, real-world datasets, Python, NumPy, Pandas, Scikit-learn, and industry-focused training with expert guidance."
    keywords="Machine Learning Course, Machine Learning Training, ML Course Online, Machine Learning Classes, Learn Machine Learning, ML Training, Python Machine Learning Course, Scikit-learn Course, Machine Learning Certification"
    canonical="https://feesworth.com/machine-learning-courses-pay-after-learn"
/>
            <CourseHeroSection
                badge="MACHINE LEARNING TRAINING"
                title="Machine Learning"
                titleHighlight="Courses"
                logo="/ML_Logo.webp"
                logoAlt="Machine Learning Logo"
                description="Learn Machine Learning through practical projects, real-world datasets, and industry-focused training."
                features={mlFeatures}
            />


            <ScrollText />


            <CourseReasons
                courseName="Machine Learning"
                badge="WHY MACHINE LEARNING?"
                description="Explore the career opportunities, technologies, and real-world applications that make Machine Learning an important skill for modern technology professionals."
                reasons={mlReasons}
            />


            <PlaceMentRecord />


            <MLSyllabus />


            {/* ML Recommended Courses */}


            <CourseFAQ
                courseName="Machine Learning"
                faqs={mlFaqs}
            />


            <GetInTouch
                courseName="Machine Learning"
            />

        </>
    );
}

export default MLPage;